<template>
  <div class="embed-snippet">
    <p class="embed-snippet-note">{{ note }}</p>
    <label class="embed-snippet-label" for="embed-snippet-code">iframe</label>
    <textarea
      id="embed-snippet-code"
      class="embed-snippet-code"
      readonly
      rows="4"
      :value="snippet"
      @focus="selectAll"
    ></textarea>
    <b-button type="button" size="sm" variant="outline-primary" class="embed-snippet-copy" @click="copy">{{ copied ? 'Copied' : 'Copy iframe' }}</b-button>
  </div>
</template>

<script>
import { embedSnippet } from '../../../shared/embed.js'

export default {
  name: 'EmbedSnippet',
  props: {
    src: { type: String, default: '' },
    title: { type: String, default: 'App' },
    note: { type: String, default: '' }
  },
  data () {
    return { copied: false }
  },
  computed: {
    snippet () {
      return embedSnippet({ src: this.src, title: this.title })
    }
  },
  watch: {
    snippet () {
      this.copied = false
    }
  },
  methods: {
    selectAll (event) {
      event.target.select()
    },
    async copy () {
      const text = this.snippet
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
      } catch (err) {
        const field = this.$el.querySelector('#embed-snippet-code')
        if (field) {
          field.focus()
          field.select()
          document.execCommand('copy')
        }
      }
      this.copied = true
    }
  }
}
</script>

<style scoped>
.embed-snippet-note {
  margin: 0 0 0.75rem;
  color: #b0b0ae;
}

.embed-snippet-label {
  display: block;
  margin-bottom: 0.35rem;
  font-weight: 600;
}

.embed-snippet-code {
  display: block;
  width: 100%;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.85rem;
}

.embed-snippet-copy {
  margin-top: 0.6rem;
}
</style>
